module.exports = "<div class=\"loading-icon\">\r\n    <ion-spinner name=\"crescent\"></ion-spinner>\r\n</div>"